<div class="share-contents desktop">
  <ng-scrollbar>
    <ng-container *ngTemplateOutlet="shareContent"></ng-container>
  </ng-scrollbar>
</div>
<div class="share-contents mobile">
  <ng-container *ngTemplateOutlet="shareContent"></ng-container>
</div>

<ng-template #shareContent>
  <div
    class="shareinfo-container"
    [class.has-toggle-panel]="hasTogglePanel && !hideAlert"
  >
    <div class="info-container-wrapper">
      <div class="share-info">
        <div class="title">{{ 'liveEvent.setup.label.share' | translate }}</div>
        @if (hasTogglePanel) {
        <mat-icon
          fontSet="material-symbols-outlined"
          (click)="toggleSection.emit()"
          class="close-sidebar"
          >right_panel_close</mat-icon
        >
        }
      </div>
      @if (!hasTogglePanel) {
      <div class="shareinfo-close" (click)="closeShareInfo.emit()">
        <mat-icon>close</mat-icon>
      </div>
      } @if (hasTogglePanel && !hideAlert) {
      <div class="start-registration-alert">
        <mat-icon>info_outline</mat-icon>
        <div class="alert-text">
          {{
            (isScheduledExam
              ? 'common.message.planTheExamFirst'
              : 'common.message.startRegistrationFirst'
            ) | translate
          }}
        </div>
      </div>
      }
      <div class="qr-code-container" data-cy="qrContainer">
        <qr-code-preview
          [qr]="qrSvg"
          [qrDataUrl]="qrDataUrl"
          [tooltip]="'course.form.qrCodeTooltip' | translate"
          dataCy="qrCode"
        ></qr-code-preview>
        <div class="qr-actions">
          <div class="zoom_in" (click)="openQrModel()" data-cy="zoomInQRModel">
            <mat-icon>zoom_out_map</mat-icon>
          </div>
        </div>
      </div>
      <div>
        <div class="pin-widget">
          <div class="link-part">{{ shortLinkPrefix }}</div>
          <div class="pin" (click)="copyPin()">
            <div
              class="input-container flex-row"
              matTooltip="{{ 'course.form.pinTooltip' | translate }}"
            >
              <div class="pin-char" data-cy="pinCharPrefix">
                {{ editionPrefix }}
              </div>
              <span class="pin-char-hyphen" data-cy="pinCharHyphen"> - </span>
              @for (char of pinCode?.split(''); track $index) {
              <div class="pin-char" data-cy="pinChar">
                {{ char }}
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="share flex-column">
      @if (openInNewTabText) {
      <div class="open-new" [matTooltip]="openInNewTabText">
        <qa-button
          mat-button
          [anchorLink]="asShortLink(pinCode)"
          [label]="'course.form.tryNow' | translate"
          [isRaisedButton]="true"
          [target]="_blank"
          icon="open_in_new"
        >
        </qa-button>
      </div>
      }
      <qa-button-link
        icon="content_copy"
        label="course.form.copyLable"
        tooltip="course.form.clipboardTooltip"
        (action)="copyWebLink()"
      ></qa-button-link>
      <qa-button-link
        icon="email"
        label="course.form.invitationViaMail"
        tooltip="course.form.invitationEmailTooltip"
        (action)="inviteAction.emit()"
      ></qa-button-link>
      @if (embedDialogData) {
      <qa-button-link
        icon="code"
        label="course.form.embedAsIFrame"
        tooltip="course.form.embedTooltip"
        (action)="embedCourse()"
      ></qa-button-link>
      } @if (canDownLoadFlyer) {
      <qa-button-link
        icon="download"
        label="exam.setup.examFlyer"
        tooltip="course.form.downloadFlyerTooltip"
        [loading]="generatingFlyer"
        loadingLabel="exam.setup.generating"
        (action)="generateFlyer.emit()"
      ></qa-button-link>
      } @if (safeExamBrowser) {
      <qa-button-link
        icon="content_copy"
        label="exam.link.safeExamBrowser"
        [showInfoIcon]="true"
        (action)="copyWebLink(true)"
        (infoAction)="openSafeExamBrowserInfoDialog()"
      ></qa-button-link>
      } @if (helpVideoDialogData) {
      <div class="tutorial">
        <qa-button
          mat-button
          (click)="openVideo()"
          [label]="'liveEvents.setup.label.accessLearners' | translate"
          icon="play_circle"
        >
        </qa-button>
      </div>
      }
    </div>
  </div>
</ng-template>
